import { createAction } from 'redux-act'

import { EsalesPanelStructure } from '../types'

export const fetchCartPraStart = createAction('Fetch cart PRA start')
export const fetchCartPraSuccess = createAction<EsalesPanelStructure>('Fetch cart PRA success')
export const fetchCartPraFail = createAction<Error>('Fetch cart PRA fail')
